(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 87794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(17704);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 43188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ postCallboxLead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);





var CALLBOX_URL = "https://scripts.callbox.co.il/mazda/forms2cb.php";
var postCallboxLead = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(formType, leadRequest) {
        var ref, ref1, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().post(CALLBOX_URL, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, leadRequest), {
                            sid: (window === null || window === void 0 ? void 0 : (ref = window.__ctm) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.sid) || "",
                            formType: formType
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function postCallboxLead(formType, leadRequest) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 87183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ popups_ErrorInFormPopup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
;// CONCATENATED MODULE: ./reusable/icons/ErrorPopIcon.tsx






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.black */.Z.black : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 77;
    var h = 77;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.50003 67.5829C1.50321 66.2686 1.80425 64.9845 2.36588 63.8591L33.1659 4.50703C33.1662 4.50638 33.1665 4.50573 33.1669 4.50508C33.7416 3.41226 34.5413 2.52598 35.4763 1.9184C36.4102 1.31147 37.4511 1 38.5 1C39.5489 1 40.5898 1.31147 41.5237 1.9184C42.4585 2.52588 43.2582 3.41196 43.8328 4.50453C43.8333 4.50536 43.8337 4.5062 43.8341 4.50703L74.6309 63.8526C74.632 63.8549 74.6331 63.8571 74.6342 63.8594C75.1958 64.9846 75.4968 66.2687 75.5 67.5829C75.5032 68.8997 75.2072 70.1884 74.6488 71.3192C74.0906 72.4498 73.2943 73.3741 72.353 74.0134C71.4152 74.6504 70.3629 74.9852 69.2995 75H7.70053C6.63714 74.9852 5.58483 74.6504 4.647 74.0134C3.70572 73.3741 2.90944 72.4498 2.35117 71.3192C1.79277 70.1884 1.49683 68.8997 1.50003 67.5829Z",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.9492 26.1016L38.9492 53.1016",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.9492 59.2031H38.9856",
                stroke: color,
                strokeWidth: "6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ var ErrorPopIcon = (SvgComponent);

// EXTERNAL MODULE: ./reusable/popups/ClassicPopUp.tsx
var ClassicPopUp = __webpack_require__(66395);
;// CONCATENATED MODULE: ./reusable/popups/ErrorInFormPopup.tsx



var ErrorInFormPopup = function(param) {
    var open = param.open, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassicPopUp/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorPopIcon, {}),
        open: open,
        title: "מצטערים, משהו השתבש",
        text: "הפנייה לא נשלחה אלינו, כדאי לנסות שוב",
        onClose: onClose
    });
};
/* harmony default export */ var popups_ErrorInFormPopup = (ErrorInFormPopup);


/***/ }),

/***/ 17704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(71537);
// EXTERNAL MODULE: ./common/MediaQueries.tsx + 5 modules
var MediaQueries = __webpack_require__(57402);
// EXTERNAL MODULE: ./common/analytics.ts + 10 modules
var analytics = __webpack_require__(87018);
// EXTERNAL MODULE: ./common/bit/form/FormikForm.tsx
var FormikForm = __webpack_require__(95055);
// EXTERNAL MODULE: ./common/bit/utils/utmParams.ts
var utmParams = __webpack_require__(21172);
// EXTERNAL MODULE: ./common/postCallboxLead.ts
var postCallboxLead = __webpack_require__(43188);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./reusable/formsComp/FormInput.tsx
var FormInput = __webpack_require__(77498);
// EXTERNAL MODULE: ./reusable/formsComp/FormSelect.tsx + 1 modules
var FormSelect = __webpack_require__(83225);
// EXTERNAL MODULE: ./reusable/formsComp/FormSuccessState.tsx
var FormSuccessState = __webpack_require__(27047);
// EXTERNAL MODULE: ./reusable/formsComp/checkbox/FormCheckBoxWithLable.tsx + 2 modules
var FormCheckBoxWithLable = __webpack_require__(34515);
// EXTERNAL MODULE: ./reusable/popups/ErrorInFormPopup.tsx + 1 modules
var ErrorInFormPopup = __webpack_require__(87183);
// EXTERNAL MODULE: ./reusable/wrappers/InnerPageWrapper.tsx
var InnerPageWrapper = __webpack_require__(45732);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
;// CONCATENATED MODULE: ./components/pages/contactUs/contactItems.tsx
var serviceItems = [
    {
        url: "https://api.whatsapp.com/send/?phone=972532397240&text&type=phone_number&app_absent=0",
        type: "page",
        label: "מענה מהיר בוואטסאפ",
        linkLabel: "053-2397240",
        icon: "whatsapp",
        blank: true
    },
    {
        url: "*2880",
        type: "phone",
        label: "מענה טלפוני 24/7",
        icon: "phone"
    },
    {
        url: "service1@delekmotors.co.il",
        type: "email",
        label: "יצירת קשר במייל",
        icon: "mail"
    }, 
];
var salesItems = [
    {
        url: "/show-rooms",
        type: "page",
        label: "אולמות תצוגה",
        linkLabel: "לתיאום ביקור",
        icon: "location"
    },
    {
        url: "*9888",
        type: "phone",
        label: "מענה טלפוני",
        extraInfo: "בימים א׳-ה׳ 08:00-17:00",
        icon: "clock"
    }, 
];

// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/pages/contactUs/ContactLink.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 20px 16px;\n\n  ",
        " {\n    flex-direction: column;\n    padding: 0 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 300;\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-decoration: underline;\n  direction: ltr;\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactLink__StyledWrapper",
    componentId: "sc-8188279d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledLabelWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactLink__StyledLabelWrapper",
    componentId: "sc-8188279d-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ContactLink__StyledTypography",
    componentId: "sc-8188279d-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledExtraInfo = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ContactLink__StyledExtraInfo",
    componentId: "sc-8188279d-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledNextLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "ContactLink__StyledNextLink",
    componentId: "sc-8188279d-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.saphire;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ContactLink = function(param) {
    var url = param.url, type = param.type, label = param.label, icon = param.icon, linkLabel = param.linkLabel, extraInfo = param.extraInfo, blank = param.blank;
    var generateLink = function() {
        if (type === "email") {
            return "mailto:".concat(url);
        }
        if (type === "phone") {
            return "tel:".concat(url);
        }
        return url;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/icons/contact/".concat(icon, ".svg"),
                alt: label,
                width: "30",
                height: "30",
                objectFit: "contain"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLabelWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTypography, {
                        children: label
                    }),
                    extraInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExtraInfo, {
                        children: extraInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNextLink, {
                        href: generateLink(),
                        openInNewTab: blank,
                        children: linkLabel || url
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contactUs_ContactLink = (ContactLink);

;// CONCATENATED MODULE: ./components/pages/contactUs/ContactLinks.tsx


function ContactLinks_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 40px 0;\n  gap: 24px;\n\n  ",
        " {\n    padding: 60px 0;\n    margin-top: 60px;\n    border-top: 1px solid ",
        ";\n    gap: 40px;\n  }\n"
    ]);
    ContactLinks_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactLinks_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 28px;\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    ContactLinks_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactLinks_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  ",
        " {\n    flex-direction: row;\n    gap: 32px;\n  }\n"
    ]);
    ContactLinks_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactLinks_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  ",
        " {\n    padding: 24px 12px;\n    border-radius: 10px;\n    border: 1px solid ",
        ";\n    gap: 32px;\n    flex-grow: 1;\n  }\n"
    ]);
    ContactLinks_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactLinks_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    ContactLinks_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 0;\n  border-radius: 10px;\n  border: 1px solid #d5d5d5;\n  display: flex;\n  flex-direction: column;\n  ",
        " {\n    padding: 0;\n    border: none;\n    flex-direction: row;\n    justify-content: space-evenly;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    displayName: "ContactLinks__StyledContainer",
    componentId: "sc-abbbe3d-0"
})(ContactLinks_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.colors.borderGrey;
});
var ContactLinks_StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ContactLinks__StyledTypography",
    componentId: "sc-abbbe3d-1"
})(ContactLinks_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledSectionWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactLinks__StyledSectionWrap",
    componentId: "sc-abbbe3d-2"
})(ContactLinks_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledLinksWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactLinks__StyledLinksWrapper",
    componentId: "sc-abbbe3d-3"
})(ContactLinks_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.colors.borderGrey;
});
var StyledLinksTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    displayName: "ContactLinks__StyledLinksTitle",
    componentId: "sc-abbbe3d-4"
})(ContactLinks_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledLinksContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactLinks__StyledLinksContainer",
    componentId: "sc-abbbe3d-5"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ContactLinks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLinks_StyledTypography, {
                variant: "h2",
                children: "אנחנו כאן בשבילך"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionWrap, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinksWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinksTitle, {
                                variant: "h3",
                                children: "שירות לקוחות"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinksContainer, {
                                children: serviceItems.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUs_ContactLink, (0,_object_spread/* default */.Z)({}, item), index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLinksWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinksTitle, {
                                variant: "h3",
                                children: "ייעוץ ומכירות"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLinksContainer, {
                                children: salesItems.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUs_ContactLink, (0,_object_spread/* default */.Z)({}, item), index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contactUs_ContactLinks = (ContactLinks);

// EXTERNAL MODULE: ./common/bit/form/FormikSchema.ts
var FormikSchema = __webpack_require__(46363);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/pages/contactUs/SchemaContactUs.ts


var regex = {
    singleName: /^[a-zA-Zא-ת'"\\.\-,\s]+$/,
    phoneNumber: /^05\d([-]{0,1})\d{7}$/
};
var schemaContactUs = es/* object */.Ry({
    subject: es/* string */.Z_().required("שדה חובה").oneOf([
        "קניית רכב",
        "שירות"
    ], "שדה חובה"),
    licenseNumber: es/* string */.Z_().nullable().when("subject", {
        is: "שירות" || 0,
        then: FormikSchema/* schemaCommon.licenseNumber.required */.Cr.licenseNumber.required("שדה חובה")
    }),
    model: es/* string */.Z_().when("subject", {
        is: "קניית רכב",
        then: es/* string */.Z_().required("שדה חובה")
    }),
    showRoom: es/* string */.Z_().when("subject", {
        is: "קניית רכב",
        then: es/* string */.Z_().required("שדה חובה")
    }),
    firstName: es/* string */.Z_().matches(regex.singleName, "יש להזין אותיות בעברית / אנגלית בלבד").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required("שדה זה הינו שדה חובה"),
    lastName: es/* string */.Z_().matches(regex.singleName, "יש להזין אותיות בעברית / אנגלית בלבד").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required("שדה זה הינו שדה חובה"),
    email: es/* string */.Z_().email("כתובת מייל אינה תקינה").required("שדה זה הינו שדה חובה"),
    phoneNumber: es/* string */.Z_().matches(regex.phoneNumber, "טלפון אינו תקין").required("שדה זה הינו שדה חובה").max(10, "יש להזין עד 10 ספרות בלבד"),
    approveMailingList: es/* boolean */.O7().notRequired(),
    message: es/* string */.Z_().max(500, "יש להזין עד 500 תווים בלבד")
}).defined();
var initialFormStatesContactUs = {
    subject: "קניית רכב",
    model: "",
    licenseNumber: "",
    showRoom: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
    approveMailingList: false
};
/* harmony default export */ var SchemaContactUs = (schemaContactUs);

;// CONCATENATED MODULE: ./components/pages/contactUs/ContactUsPage.tsx



function ContactUsPage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  .MuiFormControlLabel-root {\n    margin-right: 0px;\n  }\n"
    ]);
    ContactUsPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactUsPage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n  ",
        " {\n    width: 660px;\n  }\n"
    ]);
    ContactUsPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactUsPage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0px;\n"
    ]);
    ContactUsPage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactUsPage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: auto;\n  gap: 2px;\n  ",
        " {\n    flex-direction: row;\n    column-gap: 16px;\n  }\n"
    ]);
    ContactUsPage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactUsPage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 320px;\n"
    ]);
    ContactUsPage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ContactUsPage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: auto;\n"
    ]);
    ContactUsPage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



















var ContactSubject;
(function(ContactSubject) {
    ContactSubject["BuyCar"] = "קניית רכב";
    ContactSubject["Service"] = "שירות";
})(ContactSubject || (ContactSubject = {}));
var ContactUsPage_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactUsPage__StyledWrapper",
    componentId: "sc-14bbbc27-0"
})(ContactUsPage_templateObject());
var StyledFormDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactUsPage__StyledFormDiv",
    componentId: "sc-14bbbc27-1"
})(ContactUsPage_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    displayName: "ContactUsPage__StyledButton",
    componentId: "sc-14bbbc27-2"
})(ContactUsPage_templateObject2());
var StyledRowCol = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactUsPage__StyledRowCol",
    componentId: "sc-14bbbc27-3"
})(ContactUsPage_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactUsPage__StyledWrap",
    componentId: "sc-14bbbc27-4"
})(ContactUsPage_templateObject4());
var StyledRequiredFields = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "ContactUsPage__StyledRequiredFields",
    componentId: "sc-14bbbc27-5"
})(ContactUsPage_templateObject5(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledSelectWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ContactUsPage__StyledSelectWrap",
    componentId: "sc-14bbbc27-6"
})(_templateObject6(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$aloneInRow ? "width: calc(50% - 8px); margin-left: auto;" : "width: 100%;";
});
var FormStatus;
(function(FormStatus) {
    FormStatus["Normal"] = "normal";
    FormStatus["Success"] = "success";
    FormStatus["Error"] = "error";
})(FormStatus || (FormStatus = {}));
var ContactUsPage = function(param) {
    var modelsList = param.modelsList, showRoomsList = param.showRoomsList;
    var ref = (0,react.useState)(false), firstChangeService = ref[0], setFirstChangeService = ref[1];
    var ref1 = (0,react.useState)(false), firstChangeSales = ref1[0], setFirstChangeSales = ref1[1];
    var ref2 = (0,react.useState)(FormStatus.Normal), formStatus = ref2[0], setFormStatus = ref2[1];
    var isDesktop = (0,MediaQueries/* useIsDesktop */.Ce)();
    var showRoomsOptions = (0,FormSelect/* toFormSelectOptions */.L)(showRoomsList, "id", "name");
    var modelsOptions = (0,FormSelect/* toFormSelectOptions */.L)(modelsList.filter(function(model) {
        return model.carState === "Available";
    }), "id", "name");
    var formikRef = (0,react.useRef)();
    var router = (0,client_router.useRouter)();
    (0,react.useEffect)(function() {
        setFormStatus(FormStatus.Normal);
    }, [
        router
    ]);
    // Set subject from URL search param if present
    (0,react.useEffect)(function() {
        var params = new URLSearchParams(window.location.search);
        var subjectParam = params.get("subject");
        if (subjectParam && Object.values(ContactSubject).includes(subjectParam) && formikRef.current) {
            formikRef.current.setFieldValue("subject", subjectParam);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerPageWrapper/* default */.Z, {
            title: "זמינים בשבילך",
            subtitle: "מהצעד הראשון ולאורך כל הדרך, צוות השירות שלנו כאן לכל שאלה ועניין",
            imgUrl: isDesktop ? "/img/cover/contactus.jpg" : "/img/cover/contactusmobile.jpg",
            breadCrumbName: "ContactUs",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactUsPage_StyledWrapper, {
                            children: [
                                formStatus === FormStatus.Success && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSuccessState/* default */.Z, {}),
                                (formStatus === FormStatus.Error || formStatus === FormStatus.Normal) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
                                    innerRef: formikRef,
                                    validationSchema: SchemaContactUs,
                                    initialValues: initialFormStatesContactUs,
                                    onSubmit: function() {
                                        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
                                            var ref, ref1, utmValues, request, formResponse;
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        utmValues = (0,utmParams/* getUtmParamsAsKeyValueList */.U)();
                                                        request = {
                                                            subjectId: (values === null || values === void 0 ? void 0 : values.subject) === ContactSubject.BuyCar ? 1 : 2,
                                                            licensePlate: values === null || values === void 0 ? void 0 : values.licenseNumber,
                                                            carModelId: (values === null || values === void 0 ? void 0 : values.model) ? parseInt(values === null || values === void 0 ? void 0 : values.model) : 0,
                                                            showRoomId: (values === null || values === void 0 ? void 0 : values.showRoom) ? parseInt(values === null || values === void 0 ? void 0 : values.showRoom) : 0,
                                                            firstName: values === null || values === void 0 ? void 0 : values.firstName,
                                                            lastName: values === null || values === void 0 ? void 0 : values.lastName,
                                                            phone: values === null || values === void 0 ? void 0 : values.phoneNumber,
                                                            fax: "",
                                                            email: values === null || values === void 0 ? void 0 : values.email,
                                                            otherPhone: "",
                                                            description: values === null || values === void 0 ? void 0 : values.message,
                                                            approveMailingList: values === null || values === void 0 ? void 0 : values.approveMailingList,
                                                            contactSource: isDesktop ? "Pc" : "Mobile",
                                                            utmValues: utmValues,
                                                            sid: (window === null || window === void 0 ? void 0 : (ref = window.__ctm) === null || ref === void 0 ? void 0 : (ref1 = ref.config) === null || ref1 === void 0 ? void 0 : ref1.sid) || "",
                                                            formName: "Mazda_contactus_form"
                                                        };
                                                        return [
                                                            4,
                                                            (0,api/* postContactContact */.Gh)(request)
                                                        ];
                                                    case 1:
                                                        formResponse = _state.sent();
                                                        (0,postCallboxLead/* postCallboxLead */.b)("contact", request);
                                                        if (formResponse === null || formResponse === void 0 ? void 0 : formResponse.data) {
                                                            (0,analytics/* trackSuccessContacUs */.SU)(values === null || values === void 0 ? void 0 : values.subject, "contact_us_lead_success");
                                                            (0,analytics/* trackPersonalDetails */.AB)("ContactUs", values.email, values.phoneNumber, false);
                                                            setFormStatus(FormStatus.Success);
                                                        } else {
                                                            setFormStatus(FormStatus.Error);
                                                        }
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(values) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    render: function(formik) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormDiv, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRequiredFields, {
                                                    children: "* שדות חובה"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelectWrap, {
                                                            $aloneInRow: formik.values.subject === ContactSubject.BuyCar,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                                                name: "subject",
                                                                required: true,
                                                                label: "נושא הפנייה",
                                                                values: Object.values(ContactSubject),
                                                                map: function(item) {
                                                                    return {
                                                                        id: item,
                                                                        name: item
                                                                    };
                                                                },
                                                                onChange: function(e) {
                                                                    formik.setFieldValue("subject", e.target.value);
                                                                    if (e.target.value === ContactSubject.Service && !firstChangeService) {
                                                                        setFirstChangeService(true);
                                                                    }
                                                                    if (e.target.value === ContactSubject.BuyCar && !firstChangeSales) {
                                                                        setFirstChangeSales(true);
                                                                    }
                                                                },
                                                                focused: !formik.isSubmitting && formik.errors.subject ? true : false
                                                            })
                                                        }),
                                                        formik.values.subject !== ContactSubject.BuyCar && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                            name: "licenseNumber",
                                                            label: "מספר לוחית רישוי",
                                                            required: true
                                                        })
                                                    ]
                                                }),
                                                formik.values.subject === ContactSubject.BuyCar && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                                            name: "model",
                                                            required: true,
                                                            label: "דגם רכב",
                                                            values: modelsOptions,
                                                            map: function(item) {
                                                                return {
                                                                    id: item.id,
                                                                    name: item.name
                                                                };
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect/* default */.Z, {
                                                            name: "showRoom",
                                                            required: true,
                                                            label: "אולם תצוגה",
                                                            values: showRoomsOptions,
                                                            map: function(item) {
                                                                return {
                                                                    id: item.id,
                                                                    name: item.name
                                                                };
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                            name: "firstName",
                                                            label: "שם פרטי",
                                                            required: true,
                                                            autoComplete: "given-name"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                            name: "lastName",
                                                            label: "שם משפחה",
                                                            required: true,
                                                            autoComplete: "family-name"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRowCol, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                            name: "phoneNumber",
                                                            label: "טלפון נייד",
                                                            autoComplete: "tel-national",
                                                            required: true,
                                                            type: "tel"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                            name: "email",
                                                            label: "כתובת מייל",
                                                            autoComplete: "email",
                                                            required: true,
                                                            type: "email"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput/* default */.Z, {
                                                    name: "message",
                                                    label: "?איך נוכל לעזור",
                                                    multiline: true,
                                                    minRows: 4
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRowCol, {
                                                    "aria-label": "אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה.",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCheckBoxWithLable/* default */.Z, {
                                                        name: "approveMailingList",
                                                        label: "אני רוצה לקבל פניות ועדכונים במייל ו/או בווטסאפ ו/או בסמס מקבוצת דלק מוטורס על מבצעים, השקות, אירועים ועוד. ולהיכלל במאגר המידע של הקבוצה."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrap, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                        disabled: formik.isSubmitting,
                                                        fullWidth: true,
                                                        variant: "text",
                                                        type: "submit",
                                                        disableFocusRipple: false,
                                                        disableRipple: false,
                                                        children: "שליחה"
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorInFormPopup/* default */.Z, {
                            open: formStatus === FormStatus.Error,
                            onClose: function() {
                                return setFormStatus(FormStatus.Normal);
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUs_ContactLinks, {})
            ]
        })
    });
};
/* harmony default export */ var contactUs_ContactUsPage = (ContactUsPage);

;// CONCATENATED MODULE: ./src/pages/contact-us.tsx



var ContactUs = function(param) {
    var seo = param.seo, showRoomsList = param.showRoomsList, modelsList = param.modelsList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contactUs_ContactUsPage, {
                modelsList: modelsList,
                showRoomsList: showRoomsList
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var contact_us = (ContactUs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4245,2669,7322,4839,4747,9774,2888,179], function() { return __webpack_exec__(87794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);